import "core-js/modules/es6.promise";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // A type of promise-like that resolves synchronously and supports only one observer


var _iteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator =
/*#__PURE__*/
Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values


var _asyncIteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator =
/*#__PURE__*/
Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing


function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
} // Asynchronously await a promise and pass the result to a finally continuation


var cntState = {
  global: 0,
  models: {},
  effects: {}
};
var loadingInitialState = {
  global: 0,
  models: {},
  effects: {}
};

var createLoadingAction = function createLoadingAction(converter, i) {
  return function (state, _ref) {
    var _extends2, _extends3, _extends4;

    var name = _ref.name,
        action = _ref.action;
    cntState.global += i;
    cntState.models[name] += i;
    cntState.effects[name][action] += i;
    return _extends({}, state, {
      global: converter(cntState.global),
      models: _extends({}, state.models, (_extends2 = {}, _extends2[name] = converter(cntState.models[name]), _extends2)),
      effects: _extends({}, state.effects, (_extends4 = {}, _extends4[name] = _extends({}, state.effects[name], (_extends3 = {}, _extends3[action] = converter(cntState.effects[name][action]), _extends3)), _extends4))
    });
  };
};

var validateConfig = function validateConfig(config) {
  if (config.name && typeof config.name !== 'string') {
    throw new Error('loading plugin config name must be a string');
  }

  if (config.asNumber && typeof config.asNumber !== 'boolean') {
    throw new Error('loading plugin config asNumber must be a boolean');
  }

  if (config.whitelist && !Array.isArray(config.whitelist)) {
    throw new Error('loading plugin config whitelist must be an array of strings');
  }

  if (config.blacklist && !Array.isArray(config.blacklist)) {
    throw new Error('loading plugin config blacklist must be an array of strings');
  }

  if (config.whitelist && config.blacklist) {
    throw new Error('loading plugin config cannot have both a whitelist & a blacklist');
  }
};

var index = function index(config) {
  if (config === void 0) {
    config = {};
  }

  validateConfig(config);
  var loadingModelName = config.name || 'loading';
  var converter = config.asNumber === true ? function (cnt) {
    return cnt;
  } : function (cnt) {
    return cnt > 0;
  };
  var loading = {
    name: loadingModelName,
    reducers: {
      hide: createLoadingAction(converter, -1),
      show: createLoadingAction(converter, 1)
    },
    state: loadingInitialState
  };
  var initialLoadingValue = converter(0); // @ts-ignore

  loadingInitialState.global = initialLoadingValue;
  return {
    config: {
      models: {
        loading: loading
      }
    },
    onModel: function onModel(_ref2, rematch) {
      var name = _ref2.name; // do not run dispatch on "loading" model

      if (name === loadingModelName) {
        return;
      }

      cntState.models[name] = 0;
      cntState.effects[name] = {};
      loadingInitialState.models[name] = initialLoadingValue;
      loadingInitialState.effects[name] = {};
      var modelActions = rematch.dispatch[name]; // map over effects within models

      Object.keys(modelActions).forEach(function (action) {
        // @ts-ignore
        if (rematch.dispatch[name][action].isEffect !== true) {
          return;
        }

        cntState.effects[name][action] = 0;
        loadingInitialState.effects[name][action] = initialLoadingValue;
        var actionType = name + "/" + action; // ignore items not in whitelist

        if (config.whitelist && !config.whitelist.includes(actionType)) {
          return;
        } // ignore items in blacklist


        if (config.blacklist && config.blacklist.includes(actionType)) {
          return;
        } // copy orig effect pointer


        var origEffect = rematch.dispatch[name][action]; // create function with pre & post loading calls

        var effectWrapper = function effectWrapper() {
          for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
            props[_key] = arguments[_key];
          }

          try {
            return Promise.resolve(_catch(function () {
              rematch.dispatch.loading.show({
                name: name,
                action: action
              }); // waits for dispatch function to finish before calling "hide"

              return Promise.resolve(origEffect.apply(void 0, props)).then(function (effectResult) {
                rematch.dispatch.loading.hide({
                  name: name,
                  action: action
                });
                return effectResult;
              });
            }, function (error) {
              rematch.dispatch.loading.hide({
                name: name,
                action: action
              });
              throw error;
            }));
          } catch (e) {
            return Promise.reject(e);
          }
        };

        effectWrapper.isEffect = true; // replace existing effect with new wrapper
        // @ts-ignore

        rematch.dispatch[name][action] = effectWrapper;
      });
    }
  };
};

export default index;